//Smoothscroll also with page change reload, jumps to top and scrolls down again

//switch off in development, when browser sync is on
//with reduced motion the browser just jumps to the anchor natively
if(document.getElementById('__bs_script__') === null && !prefersReducedMotion()){
    // to top right away
    if ( window.location.hash )scroll(0,0);
// void some browsers issue
    setTimeout( function() {
        scroll(0, 0);
    }, 50);

    window.addEventListener('load', function () {
        setTimeout(function () {
            if (window.location.hash) {
                // smooth scroll to the anchor id
                $('html, body').animate({
                    scrollTop: $(window.location.hash).offset().top + 'px'
                }, 500);
            }
        }, 50);
    });
}

//smoothscroll for links with hash
$(function() {
    //@fixme avoid to kill standard bs4 functionality like collapse elements
    $("a").on('click', function(event) {
        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
            // Store hash
            var hash = this.hash;
            // Using jQuery's animate() method to add smooth page scroll
            // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
            $('html, body').animate({
                scrollTop: $(hash).offset().top
            }, prefersReducedMotion() ? 0 : 500, function() {
                // Add hash (#) to URL when done scrolling (default click behavior)
                if (history.pushState) {
                    // IE10, Firefox, Chrome, etc.
                    window.history.pushState(null, null, hash);
                }else{
                    window.location.hash = hash;
                }
            });
            return false;
        } // End if
    });

});